<!--  -->
<template>
  <div>
    <el-form ref="numberValidateForm" :model="form" label-width="100px">
      <el-form-item label="产品型号">
        <el-input v-model="form.materialModel"></el-input>
      </el-form-item>
      <el-form-item label="产品批号">
        <el-input v-model="form.batchNo"></el-input>
      </el-form-item>
      <el-form-item label="产品序列号">
        <el-input v-model="form.productNo"></el-input>
      </el-form-item>
      <el-form-item label="激活码">
        <el-input v-model="form.serveCode"></el-input>
      </el-form-item>
      <el-form-item label="箱码">
        <el-input v-model="form.parentCode"></el-input>
      </el-form-item>
      <el-form-item label="操作账户">
        <el-input v-model="form.opUser"></el-input>
      </el-form-item>
      <el-form-item label="收货账号">
        <el-input v-model="form.receiver"></el-input>
      </el-form-item>
      <el-form-item label="操作时间">
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="选择开始日期"
            v-model="form.opStartTime"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
        <el-col :span="2" class="line">-</el-col>
        <el-col :span="11">
          <el-date-picker
            placeholder="选择结束日期"
            v-model="form.opEndTime"
            style="width: 100%;"
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item class="buttonGroup">
        <el-button type="primary" @click="onSubmit">搜索</el-button>
        <el-button @click="onClear('numberValidateForm')">清空</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  props: {
    path: {
      type: String
    }
  },
  // import引入的组件需要注入到对象中才能使用
  components: {},

  data() {
    // 这里存放数据
    return {
      form: {
        materialModel: '',
        batchNo: '',
        productNo: '',
        serveCode: '',
        parentCode: '',
        opUser: '',
        receiver: '',
        opStartTime: '',
        opEndTime: ''
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    onSubmit() {
      this.$emit('childDoFn', this.form)
    },
    onClear(formName) {
      this.form = {
        materialModel: '',
        batchNo: '',
        productNo: '',
        serveCode: '',
        parentCode: '',
        opUser: '',
        receiver: '',
        opStartTime: '',
        opEndTime: ''
      }
      this.$refs[formName].resetFields()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style>
.line {
  text-align: center;
  font-weight: 700;
}
.buttonGroup {
  margin: 0;
  text-align: center;
}
.buttonGroup .el-form-item__content {
  margin: 0 !important;
}
</style>
